import { render, staticRenderFns } from "./sliderDesktop.vue?vue&type=template&id=0e13c360&"
import script from "./sliderDesktop.vue?vue&type=script&lang=js&"
export * from "./sliderDesktop.vue?vue&type=script&lang=js&"
import style0 from "./sliderDesktop.vue?vue&type=style&index=0&id=0e13c360&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports